export type ClrEntry = {
  value: number
  label: string
  color: string
}

function clamp255(value: number): number {
  return Math.max(0, Math.min(255, Math.round(value)))
}

export function rgbToHex(r: number, g: number, b: number): string {
  return `#${[clamp255(r), clamp255(g), clamp255(b)]
    .map(channel => channel.toString(16).padStart(2, "0"))
    .join("")}`.toUpperCase()
}

/** Parse QGIS .clr text: `value red green blue alpha [label]`. */
export function parseClrText(text: string): ClrEntry[] {
  const entries: ClrEntry[] = []

  for (const rawLine of text.split(/\r?\n/)) {
    const line = rawLine.trim()
    if (!line || line.startsWith("#")) continue

    const parts = line.split(/\s+/)
    if (parts.length < 5) continue

    const value = Number.parseInt(parts[0], 10)
    const r = Number.parseInt(parts[1], 10)
    const g = Number.parseInt(parts[2], 10)
    const b = Number.parseInt(parts[3], 10)
    if (!Number.isFinite(value) || !Number.isFinite(r) || !Number.isFinite(g) || !Number.isFinite(b)) {
      continue
    }

    entries.push({
      value,
      label: parts.slice(5).join(" ").trim(),
      color: rgbToHex(r, g, b),
    })
  }

  return entries
}
